import React from 'react';
import {Change} from "../Change";
import LockCompetitor from "../../Button/LockCompetitor";
import {Carousel} from "react-bootstrap";

const CarouselCompetitor = ({
                                    setPrimaryAndSecondaryVehicles,
                                    setSecondaryVehicles,
                                    t,
                                    isLocked,
                                    checkLockStatus,
                                    changeHandler,
                                    handleToggle,
                                    handleChangeModalClose,
                                    vehicleData,
                                    setVehicleData,
                                    openModal,
                                    setOpenModal,
                                    secondaryYear,
                                    vehiclesMakes,
                                    vehicleModel,
                                    trimModel,
                                    setTrimModel,
                                    setVehicleModel,
                                    setVehicleMake,
                                    vehiclesTrim,
                                    vehicleIndex,
                                    vehicleTypeName,
                                    driveType,
                                    setDriveType,
                                    buildTablet,
                                    buildMissingCarousel,
                                    trimCodes,
                                    dispatch,
                                    getCarouselIndexKey,

                              }) => {

    return (
        <React.Fragment>

                {
                    <React.Fragment>

                        <div >
                            <Carousel
                                indicators={false}
                                interval={null}
                                controls={false}
                                defaultActiveIndex={0}
                                onSelect={(eventKey, event) => dispatch(getCarouselIndexKey(eventKey))}
                            >
                                {setSecondaryVehicles.map((vehicle, index) => {
                                    return buildTablet(vehicle, index);
                                })}
                                <Carousel.Item id={2}>
                                    <div className="competitor-vehicle-overview">
                                        <div className="no-vehicle"> {t('overview.noVehicleSelected')}</div>
                                    </div>
                                    <div className={"change-modal"}>
                                        <button
                                            id={setSecondaryVehicles.length}
                                            className={isLocked && checkLockStatus(setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length], isLocked,setSecondaryVehicles.length) ? "btn-default btn-change-disabled" :"btn-default btn-change-compare"}
                                            value={""}
                                            onClick={(event) => changeHandler(setSecondaryVehicles.length, "")}
                                            title={checkLockStatus(setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length], isLocked,setSecondaryVehicles.length)? t("overview.changeSelectModal.vehicleLocked") : null}
                                        >
                                            {t('overview.controls.selectVehicle')}
                                        </button>

                                        <LockCompetitor isLocked={isLocked}
                                                        vehicle={setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length]}
                                                        vehicleIndex = {2}
                                                        trimCodes={trimCodes}
                                                        toggleLock={() =>handleToggle(setSecondaryVehicles.length,setPrimaryAndSecondaryVehicles[setSecondaryVehicles.length])} />
                                        <Change
                                            vehicleData={vehicleData}
                                            setVehicleData={setVehicleData}
                                            openModal={openModal}
                                            setOpenModal={setOpenModal}
                                            handleModalClose={handleChangeModalClose}
                                            years={secondaryYear}
                                            vehicleMake={vehiclesMakes}
                                            vehicleModels={vehicleModel}
                                            trimModel={trimModel}
                                            setTrimModel={setTrimModel}
                                            setVehicleModel={setVehicleModel}
                                            setVehicleMake={setVehicleMake}
                                            vehiclesTrim={vehiclesTrim}
                                            vehicleIndex={vehicleIndex}
                                            vehicleTypeName={vehicleTypeName}
                                            driveType={driveType}
                                            setDriveType={setDriveType}
                                            lockedVehicle={isLocked}
                                        />
                                    </div>
                                </Carousel.Item>
                                { setSecondaryVehicles.length <=3 && setPrimaryAndSecondaryVehicles[0] &&
                                buildMissingCarousel(setSecondaryVehicles.length, "")
                                }
                            </Carousel>
                        </div>
                    </React.Fragment>
                }

        </React.Fragment>
    );
};

export default CarouselCompetitor;
